import { Ortak } from './../../../providers/ortak';
import { Component } from '@angular/core';
import {   NavController, NavParams, ViewController } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';



@Component({
  selector: 'page-banka-hareket',
  templateUrl: 'banka-hareket.html',
})
export class BankaHareketPage {
  KasaHareket:any={ID:-1,KasaID:"",BelgeNo:"",IslemTuru:6,Sign:0,CardRef:"",Tutar:"",SlsMan:"",Text:"",AciklamaRef:1};
  BankaHareket:any={ID:-1,BankRef:"",IslemTuru:1,CardRef:"",BelgeNo:"",KasaRef:"",SlsMan:"",Text:"",Sign:1,Tutar:""};
  KasaListesi=[];
  BankaListesi=[];
  aranan="";
  skip:number=0;
  take:number=50;
  BankaVw:any={};
  Banka:any={ID:-1,Name:""};
  aktifKullanici:any;

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
    if (navParams.get("BankaVw") != null) {
      this.BankaVw = navParams.get("BankaVw");

      var data = new FormData();
      data.append("Banka_id", this.BankaVw.ID);
    

      this.bllOrtak.islem(data, "BankaGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.Banka = Sonuc.SonucObject;
        

        this.BankaHareket.BankRef = this.Banka.ID;
      
     
        

      }
      )
    }
    this.aktifKullanici = this.ortak.aktifKullaniciAdi
  
  }

  ionViewDidLoad() {
    this.kasagetir();
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.KasaHareket.Tutar == null || this.KasaHareket.Tutar == "") {
      mesaj = mesaj + "Lütfen cari adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kasagetir(){
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KasaListesi", "", false).then(a => {
     
      var sonuc = <any>a;
      this.KasaListesi = sonuc.SonucObject;
     
  
    })
  }
  kaydet() {

    var formData = new FormData();
    this.BankaHareket.KasaRef=this.KasaHareket.KasaID;
    this.BankaHareket.Tutar = this.KasaHareket.Tutar;
    this.BankaHareket.Text = this.KasaHareket.Text;
    this.BankaHareket.SlsMan=this.aktifKullanici;
    this.KasaHareket.SlsMan=this.aktifKullanici;

    formData.append("BankaHareket_json", JSON.stringify(this.BankaHareket));
    formData.append("Kasa_json", JSON.stringify(this.KasaHareket));



    this.bllOrtak.islem(formData, "BankaHareket", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      if(sonuc.Sonuc==99)
      {

      }

    })


  }
  kapat() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/BankaIslemleri/banka-hareket/banka-hareket.ts